// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"712":"9c646ac36a185d36","1767":"c5fde5538fb01b7f"}[chunkId] + ".js";
};